import { configureStore } from '@reduxjs/toolkit';
import walletReducer from './wallet.reducer';

export const store = configureStore({
    reducer: {
        wallet: walletReducer,
    },
})

export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch